/**
 * Query keys of everything that reads the tenant's ACTIVE headcount, and
 * the one helper that flushes them. Kept dependency-free (type-only
 * imports) so `npm run test:unit` can load it under Node.
 *
 *  - SEATS_QUERY_KEY        GET /api/v1/employees/seats — "8 of 10 used",
 *                           the hire dialog and the over-limit banner
 *  - SETUP_STATUS_QUERY_KEY GET /api/v1/setup/status — the first-run
 *                           checklist ("Add your team", pay-data coverage)
 */

import type { QueryClient } from "@tanstack/react-query";

export const SEATS_QUERY_KEY = ["employees", "seats"] as const;
export const SETUP_STATUS_QUERY_KEY = ["setup", "status"] as const;

export const HEADCOUNT_QUERY_KEYS = [SEATS_QUERY_KEY, SETUP_STATUS_QUERY_KEY] as const;

/**
 * Flush the headcount readers after anything that changes who is active —
 * add, rehire, bulk import, deactivate / reactivate, exit close. Before
 * this (F198) the meter kept "9 of 10 used" for up to 30s after the 10th
 * person was added, and the "Add your team" step stayed open.
 */
export function invalidateHeadcount(qc: Pick<QueryClient, "invalidateQueries">): void {
  for (const queryKey of HEADCOUNT_QUERY_KEYS) {
    void qc.invalidateQueries({ queryKey });
  }
}
